import {addBreadcrumb, Breadcrumb} from '@sentry/browser';

import * as logging from 'util/Logging';

export default function attemptCaptureBreadcrumb(crumb: Breadcrumb): void {
  try {
    addBreadcrumb(crumb);
    // eslint-disable-next-line benchlint/always-throw-from-catch
  } catch (e) {
    logging.warn('Unable to capture Sentry breadcrumb:', {extra: {crumb, e}});
  }
}
